import formatDateInLocalTimezone from '../../utils/dateFormatting'

const PublishDateCell = () => {
  return ({ publish_timestamp }) => {
    if (!publish_timestamp) {
      return null
    }

    return formatDateInLocalTimezone(publish_timestamp)
  }
}

export default PublishDateCell
